import React, { useEffect, useState } from "react";
import { Button, Checkbox, Modal } from "antd";
import { PiMicrosoftExcelLogoThin } from "react-icons/pi";
import * as XLSX from "xlsx";
import dayjs from "dayjs";
import "../style.css";

const ExportExcel = ({ isExportExcel, setIsExportExcel, data }) => {
  const [allFields, setAllFields] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);

  useEffect(() => {
    const keys = Object.keys(fieldLabels);
    setAllFields(keys);

    // marcar só esses três por padrão
    setSelectedFields(["id", "dataCadastro", "usuarioAtribuicao.id"]);
  }, [data]);

  const fieldLabels = {
    //
    id: "ID OS",
    dataCadastro: "Data de Cadastro",
    "usuarioAtribuicao.id": "ID do Usuário Atribuição",

    // Dados cadastrais
    "cliente.id": "ID do Cliente",
    "cliente.dataCadastro": "Data de Cadastro do Cliente",
    "cliente.carteira.id": "ID da Carteira",

    "cliente.equipe.id": "ID da Equipe",

    "cliente.nome": "Nome do Cliente",
    "cliente.nomeFantasia": "Nome Fantasia",
    "cliente.tipoPessoa": "Tipo de Pessoa",
    "cliente.cpf": "CPF",
    "cliente.cnpj": "CNPJ",
    "cliente.matriz": "Matriz",

    "usuarioAlteracao.id": "ID do Usuário Alteração",
    dataAlteracao: "Data de Alteração",

    "tipo.nome": "Tipo de Ordem",

    dataCriacao: "Data de Criação",
    diasCriacao: "Dias desde Criação",

    "usuarioSituacao.id": "ID do Usuário Situação",
    "situacao.nome": "Nome da Situação",
    dataSituacao: "Data da Situação",

    descricao: "Descrição",
    dataVencimento: "Data de Vencimento",

    valorAvulso: "Valor Avulso",
    valorMensal: "Valor Mensal",
    valorAssinatura: "Valor da Assinatura",
    valorAdicional: "Valor Adicional",
    qtdRecorrencias: "Quantidade de Recorrências",

    qtdDiasAntecipados: "Quantidade de Dias Antecipados",

    "empresa.regimeTributario.id": "ID do Regime Tributário",

    "empresa.nome": "Nome da Empresa",
    "empresa.nomeFantasia": "Nome Fantasia",

    "empresa.ativa": "Empresa Ativa",
    "empresa.simplesNacional": "Simples Nacional",

    "empresa.endereco.cidade": "Cidade",
    "empresa.endereco.uf": "UF",

    "empresa.dataAbertura": "Data de Abertura",
    "empresa.dataMigracao": "Data de Migração",
    "empresa.dataEncerramento": "Data de Encerramento",

    "cliente.dataConstituicao": "Data de Constituição",
    "cliente.dataEncerramento": "Data de Encerramento",

    "cliente.dataPedidoSN": "Data do Pedido SN",
    "cliente.dataOpcaoSN": "Data de Opção SN",
    "cliente.faixaFaturamento": "Faixa de Faturamento",
    "cliente.faturamentoExcedido": "Faturamento Excedido",
    "cliente.capitalSocial": "Capital Social",
    "cliente.observacao": "Observação",
  };

  const flattenObject = (obj, prefix = "") => {
    const result = {};
    for (const key in obj) {
      const value = obj[key];
      const newKey = prefix ? `${prefix}.${key}` : key;
      if (typeof value === "object" && value !== null && !Array.isArray(value)) {
        Object.assign(result, flattenObject(value, newKey));
      } else {
        result[newKey] = value;
      }
    }
    return result;
  };

  const handleExport = () => {
    const selectedData = data.map((item) => {
      const flat = flattenObject(item);
      const row = {};

      selectedFields.forEach((field) => {
        let value = flat[field];
        if (
          typeof value === "number" &&
          field.toLowerCase().includes("data") &&
          value > 100000000000
        ) {
          value = dayjs(value).format("DD/MM/YYYY");
        }
        const label = fieldLabels[field] || field;
        row[label] = value !== undefined ? value : "";
      });

      return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(selectedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Exportação");

    XLSX.writeFile(workbook, "exportacao-dinamica.xlsx");
    setIsExportExcel(false);
  };

  return (
    <>
      <Modal
        title="Exportar Excel"
        open={isExportExcel}
        onCancel={() => setIsExportExcel(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsExportExcel(false)}>
            Cancelar
          </Button>,
          <Button
            key="export"
            type="primary"
            onClick={handleExport}
            style={{ background: "#005A9E", color: "#fff" }}
          >
            Exportar
          </Button>,
        ]}
      >
        <div className="flex-excel">
          <div className="excel">
            <PiMicrosoftExcelLogoThin />
          </div>
        </div>

        <div style={{ display: "grid" }}>
          <Checkbox
            checked={selectedFields.length === allFields.length}
            onChange={(e) => setSelectedFields(e.target.checked ? allFields : [])}
          >
            Selecionar Todos
          </Checkbox>

          {allFields.map((field) => (
            <Checkbox
              key={field}
              checked={selectedFields.includes(field)}
              onChange={(e) => {
                const checked = e.target.checked;
                setSelectedFields((prev) =>
                  checked ? [...prev, field] : prev.filter((f) => f !== field)
                );
              }}
            >
              {fieldLabels[field] || field}
            </Checkbox>
          ))}
        </div>
      </Modal>
    </>
  );
};

export default ExportExcel;
